///<reference path="../../yield-management-program.module.ts"/>

module Meevo.Plugins.YieldManagementProgram {
  "use strict";

  export class ScheduledMaintenanceForm implements angular.IDirective {

    restrict = "E";
    scope = {
      context: "=",
      searchContext: "=",
      headerContentKey: "@",
      visualState: "=",
      selectedItemId: "=",
      initialEditSection: "=",
      disableCrud: "=",
      hideSearch: "=",
      hideDate: "=",
      shortCutGroup: "=",
      showCoBar: "=?",
      instructionsLabel: "@"
    };

    templateUrl = 'app/plugins/yieldManagementProgram/components/ym-maintenance-form/scheduled-maintenance-form-template.html';
    require = '^form';

    link = (scope: any, element: angular.IAugmentedJQuery, attributes: angular.IAttributes, formCtrl: any) => {
      // data maintenance form for searchable entity
      if (_.isUndefined(scope.showCoBar))
        scope.showCoBar = true;
      // Exposes compiled handlebars template
      scope.applySearchResultTemplate = (item: any): string => {
        if (scope.context && scope.context.searchResultTemplateFunction) {
          return scope.context.searchResultTemplateFunction(item);
        } else {
          return "";
        }
      }

      // non-searchable data maintenance form will not support quick dropdown results
      scope.showMobileMenu = () => {
        if (!scope.mobileMenu) {
          scope.mobileMenu = true;
        } else {
          scope.mobileMenu = false;
        }
      }

      scope.submitForm = (): void => {
        angular.forEach(formCtrl, function (value, key) {
          if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue'))
            formCtrl[key].$dirty = true;
        });

        if (formCtrl.$valid && !formCtrl.$pending) {
          this.busyService.start();
          scope.context.save().finally(() => {
            this.busyService.stop();
          });
        }
      }

      scope.cancel = (): void => {
          console.log("CANCEL HIT");
        scope.context.cancel();
        formCtrl.$setPristine();
      }

      scope.detail = (id: Guid): void => {
          scope.selectedItemId = id;
          // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
          if (scope.initialEditSection)
              scope.initialEditSection = undefined;
        scope.visualState = Model.MaintenanceFormVisualState.Detail;
      }

      scope.search = (): void => {
        scope.selectedItemId = null;
        scope.visualState = Model.MaintenanceFormVisualState.Search;
      }

      scope.closeContext = (): void => {
        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
      }

      if(scope.shortCutGroup) {
        this.shortCutsService.maintenanceFormDirectiveWrapper(scope);
      }
    }

    constructor(private $rootScope: angular.IRootScopeService,
      private $state: angular.ui.IStateService,
      private $document: angular.IDocumentService,
      private busyService: Meevo.Components.Busy.IBusyService,
      private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {

    }


    static factory(): angular.IDirectiveFactory {
      let directive = ($rootScope: angular.IRootScopeService, $state: angular.ui.IStateService,
        $document: angular.IDocumentService, busyService: Meevo.Components.Busy.IBusyService, shortCutsService) => {
        return new ScheduledMaintenanceForm($rootScope, $state, $document, busyService, shortCutsService);
      };

      directive.$inject = ["$rootScope", "$state", "$document", "meevo.components.busy.BusyService", "meevo.components.short-cuts.ShortCutsService"];

      return directive;
    }
  }

  angular.module("meevo.plugins.yieldManagementProgram")
    .directive("meevoYmMaintenanceForm", ScheduledMaintenanceForm.factory());
}
